import StoreConfigString from '../../form-elements/StoreConfigString';
import { StoreConfigWidgetProps } from '../../types/store-config-widget';

function StoreConfigStringWidget(props: StoreConfigWidgetProps) {
  return (
    <StoreConfigString
      value={props.value}
      onChange={props.onChange}
      path={props.options?.path}
      id={props.id}
      onFocus={props.onFocus}
    />
  );
}

export default StoreConfigStringWidget;
